"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var DynamicComponent_1 = require("./DynamicComponent");
var DynamicDirective_1 = require("./DynamicDirective");
var DynamicBase_1 = require("./DynamicBase");
var DynamicCache_1 = require("./DynamicCache");
var DynamicComponentModule = (function () {
    function DynamicComponentModule() {
    }
    return DynamicComponentModule;
}());
DynamicComponentModule.decorators = [
    { type: core_1.NgModule, args: [{
                providers: [
                    DynamicCache_1.DynamicCache,
                    { provide: DynamicBase_1.DYNAMIC_TYPES.DynamicExtraModules, useValue: [] }
                ],
                declarations: [
                    DynamicComponent_1.DynamicComponent,
                    DynamicDirective_1.DynamicDirective
                ],
                exports: [
                    DynamicComponent_1.DynamicComponent,
                    DynamicDirective_1.DynamicDirective
                ]
            },] },
];
/** @nocollapse */
DynamicComponentModule.ctorParameters = function () { return []; };
exports.DynamicComponentModule = DynamicComponentModule;
var DynamicComponentModuleFactory = (function () {
    function DynamicComponentModuleFactory() {
    }
    DynamicComponentModuleFactory.buildModule = function (dynamicExtraModules) {
        var DynamicComponentFactoryModule = (function () {
            function DynamicComponentFactoryModule() {
            }
            return DynamicComponentFactoryModule;
        }());
        DynamicComponentFactoryModule.decorators = [
            { type: core_1.NgModule, args: [{
                        providers: [
                            DynamicCache_1.DynamicCache,
                            { provide: DynamicBase_1.DYNAMIC_TYPES.DynamicExtraModules, useValue: dynamicExtraModules }
                        ],
                        declarations: [
                            DynamicComponent_1.DynamicComponent,
                            DynamicDirective_1.DynamicDirective
                        ],
                        exports: [
                            DynamicComponent_1.DynamicComponent,
                            DynamicDirective_1.DynamicDirective
                        ]
                    },] },
        ];
        /** @nocollapse */
        DynamicComponentFactoryModule.ctorParameters = function () { return []; };
        return DynamicComponentFactoryModule;
    };
    return DynamicComponentModuleFactory;
}());
exports.DynamicComponentModuleFactory = DynamicComponentModuleFactory;
//# sourceMappingURL=DynamicComponentModule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-dynamic-component/DynamicComponentModule.js
// module id = 537
// module chunks = 3